export const APP = "APP";
export const DIALOG_SET = "DIALOG_SET";
export const DIALOG_CLOSE = "DIALOG_CLOSE";
export const DIALOG_DATA_ADD = "DIALOG_DATA_ADD";
export const RADIO_STATE_CHANGE = "RADIO_STATE_CHANGE";
export const SWITCH_STATE_CHANGE = "SWITCH_STATE_CHANGE";
export const MOUSE_ACTUALIZE = "MOUSE_ACTUALIZE";
export const ZOOM_ACTUALIZE = "ZOOM_ACTUALIZE";
export const ZOOM_ACTUALIZE_2 = "ZOOM_ACTUALIZE_2";
export const ZOOM_ACTUALIZE_3 = "ZOOM_ACTUALIZE_3";

export const ADMIN = "ADMIN";

export const USER = "USER";
export const USERS = "USERS";
export const USER_INFO = "USER_INFO";
export const USER_DELETE = "USER_DELETE";
export const USER_REACTIVATE = "USER_REACTIVATE";
export const USER_SET = "USER_SET";

export const EXPOSITIONS = "EXPOSITIONS";
export const EXPOSITIONS_FILTER = "EXPOSITIONS_FILTER";
export const EXPOSITIONS_PAGER = "EXPOSITIONS_PAGER";
export const EXPO_SET = "EXPO_SET";
export const EXPO_STRUCTURE_SET = "EXPO_STRUCTURE_SET";
export const EXPO_STRUCTURE_SCREEN_SET = "EXPO_STRUCTURE_SCREEN_SET";
export const EXPO_RENAME = "EXPO_RENAME";
export const EXPO_STATE_CHANGE = "EXPO_STATE_CHANGE";
export const EXPO_DELETE = "EXPO_DELETE";
export const EXPO_ADD = "EXPO_ADD";
export const EXPO_COLLABORATOR_ADD = "EXPO_COLLABORATOR_ADD";
export const EXPO_COLLABORATOR_DELETE = "EXPO_COLLABORATOR_DELETE";
export const EXPO_COLLABORATOR_TYPE = "EXPO_COLLABORATOR_TYPE";
export const EXPO_EDITOR_UPDATE = "EXPO_EDITOR_UPDATE";
export const EXPO_UPDATE = "EXPO_UPDATE";
export const EXPO_SCREEN_SET = "EXPO_SCREEN_SET";
export const EXPO_SCREEN_UPDATE = "EXPO_SCREEN_UPDATE";
export const EXPO_SCREEN_COLLABORATORS_ADD = "EXPO_SCREEN_COLLABORATORS_ADD";
export const EXPO_SCREEN_COLLABORATORS_CHANGE =
  "EXPO_SCREEN_COLLABORATORS_CHANGE";
export const EXPO_SCREEN_COLLABORATORS_SWAP = "EXPO_SCREEN_COLLABORATORS_SWAP";
export const EXPO_SCREEN_COLLABORATORS_DELETE =
  "EXPO_SCREEN_COLLABORATORS_REMOVE";
export const EXPO_SCREEN_DOCUMENT_ADD = "EXPO_SCREEN_DOCUMENT_ADD";
export const EXPO_SCREEN_DOCUMENT_CHANGE = "EXPO_SCREEN_DOCUMENT_CHANGE";
export const EXPO_SCREEN_DOCUMENT_DELETE = "EXPO_SCREEN_DOCUMENT_DELETE";
export const EXPO_SCREEN_DOCUMENT_SWAP = "EXPO_SCREEN_DOCUMENT_SWAP";

export const EXPO_VIEWER = "EXPO_VIEWER";
export const EXPO_VIEWER_FILE_LOADED = "EXPO_VIEWER_FILE_LOADED";
export const EXPO_VIEWER_FILES_TOTAL = "EXPO_VIEWER_FILES_TOTAL";
export const EXPO_VIEWER_AUDIO_FILE_LOADED = "EXPO_VIEWER_AUDIO_FILE_LOADED";
export const EXPO_VIEWER_AUDIO_FILES_TOTAL = "EXPO_VIEWER_AUDIO_FILES_TOTAL";
export const EXPO_VIEWER_VIDEO_FILE_LOADED = "EXPO_VIEWER_VIDEO_FILE_LOADED";
export const EXPO_VIEWER_VIDEO_FILES_TOTAL = "EXPO_VIEWER_VIDEO_FILES_TOTAL";
export const EXPO_VIEWER_FILE_ERROR_ADD = "EXPO_VIEWER_FILE_ERROR_ADD";
export const EXPO_VIEWER_FILE_ERROR_TIMEOUT_ADD = "EXPO_VIEWER_FILE_ERROR_TIMEOUT_ADD";

export const TAB_FOLDER = "TAB_FOLDER";
export const TAB_FILE = "TAB_FILE";



// WEBPACK FOOTER //
// ./src/actions/constants.js